<template>
    <div>
        manage
         <slot />
    </div>
</template>